import _ from 'lodash'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  updateStatus,
  updateUsername,
  updateRole,
  fetchUsers,
  showActivateDialog,
  closeActivateDialog,
  selectActivateCompany,
  selectActivateBuilding,
  activateUser,
  updateFilter,
  updateBuildings,
  updateCompanies,
  deleteUser,
  resendVerificationEmail,
  closeResentEmail,
  changePage,
  changeSearchString,
  closeUsernameDialog,
  showUsernameDialog,
  currentUsernameChanged,
  showInactiveUsers,
  currentEmailChanged,
  showEmailDialog,
  updateEmail,
  showSpinner,
  resentEmailFailed,
  showDevicesInformation,
  closeDevicesInformation
} from '../actions/users'
import { fetchBuildings } from '../actions/buildings.js'
import { fetchCompanies } from '../actions/companies.js'
import { validateEmail } from '../utils/emailVerificationForm'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Card, CardText } from 'material-ui/Card'
import Divider from 'material-ui/Divider'
import { Table, TableBody, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import FlatButton from 'material-ui/FlatButton'
import CircularProgress from 'material-ui/CircularProgress'
import Dialog from 'material-ui/Dialog'
import Delete from 'material-ui/svg-icons/action/delete'
import ConfirmButton from 'material-ui-confirm-button'
import Pagination from 'material-ui-pagination'
import TextField from 'material-ui/TextField'
import Edit from 'material-ui/svg-icons/image/edit'
import Toggle from 'material-ui/Toggle'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import './Users.css'

library.add(fab, fas)

const AccountStatus = {
  ALL: ' ',
  ACTIVE: 'active',
  REQUIRES_ACTIVATION: 'requiresActivation',
  REQUIRES_MANUAL_ACTIVATION: 'requiresManualActivation',
  DISABLED: 'disabled',
  PENDING_REGISTRATION: 'pendingRegistration'
}

const UserRole = {
  TENANT: 'tenant',
  BROKER: 'broker',
  MANAGER: 'manager',
  PROGRAM_MANAGER: 'program_manager',
  COMPANY_MANAGER: 'company_manager',
  BUILDING_MANAGER: 'building_manager'
}

const style = {
  margin: 0
}

const iconStyle = {
  margin: 0,
  padding: 0,
  minWidth: 0,
  width: 50
}

const isMobile = typeof window.orientation !== 'undefined'

class Users extends Component {
  static search = ''

  static defaultProps = {
    typedUsername: '',
    display: 10,
    pageNumber: 1,
    itemsPerPage: 50,
    showActivateDialog: false,
    selectedUser: null,
    showSpinner: false,
    statuses: [
      { value: AccountStatus.ACTIVE, name: 'Active' },
      { value: AccountStatus.REQUIRES_ACTIVATION, name: 'Email Verification Required' },
      { value: AccountStatus.REQUIRES_MANUAL_ACTIVATION, name: 'Requires Manual Activation' },
      { value: AccountStatus.DISABLED, name: 'Disabled' },
      { value: AccountStatus.PENDING_REGISTRATION, name: 'Registered by PM' }
    ],
    filterStatuses: [
      { value: AccountStatus.ACTIVE, name: 'Active' },
      { value: AccountStatus.REQUIRES_ACTIVATION, name: 'Email Verification Required' },
      { value: AccountStatus.REQUIRES_MANUAL_ACTIVATION, name: 'Requires Manual Activation' },
      { value: AccountStatus.DISABLED, name: 'Disabled' },
      { value: AccountStatus.PENDING_REGISTRATION, name: 'Registered by PM' }
    ],
    roles: [
      { value: UserRole.TENANT, name: 'Tenant' },
      { value: UserRole.PROGRAM_MANAGER, name: 'Program Manager' },
      { value: UserRole.COMPANY_MANAGER, name: 'Company Manager' },
      { value: UserRole.BUILDING_MANAGER, name: 'Building Manager' }
    ],
    filter: {
      buildingId: ' ',
      companyId: ' ',
      status: ' ',
      searchString: ' '
    }
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { dispatch } = this.props
    this.fetchPageUsers()
    dispatch(fetchCompanies())
    dispatch(fetchBuildings())
    this.performUsernameChange = this.performSearchSTringChanged.bind(this)
    this.performUsernameChange = _.debounce(this.performSearchSTringChanged, 500)
    document.title = 'Users - Admin - Better Spaces'
  }

  componentDidUpdate() {
    if (this.props.pageOrFilterChanged) {
      this.fetchPageUsers()
    }
  }

  fetchPageUsers() {
    const { dispatch } = this.props
    dispatch(
      fetchUsers(
        {
          ...this.props.filter,
          searchString: this.props.searchString
            ? this.props.searchString.trim().replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
            : '',
          inactiveUsersOnly: this.props.showInactiveUsers
        },
        (this.props.pageNumber - 1) * this.props.itemsPerPage,
        this.props.itemsPerPage
      )
    )
  }

  updateUserStatus(userIndex, event, index, value) {
    const { dispatch } = this.props
    let selectedUser = this.props.users.find( user => user.index == userIndex)
    if (selectedUser) {
      dispatch(updateStatus(selectedUser._id, value))
    }
  }

  updateUserUsername() {
    const { dispatch } = this.props
    dispatch(updateUsername(this.props.selectedUser._id, this.props.typedUsername))
  }

  updateUserEmail() {
    this.showSpinner()
    const { dispatch } = this.props
    dispatch(updateEmail(this.props.selectedUser._id, this.props.typedEmail))
  }

  updateUserRole(userIndex, event, index, value) {
    const { dispatch } = this.props
    let selectedUser = this.props.users.find( user => user.index == userIndex)
    if (selectedUser) {
      dispatch(updateRole(selectedUser._id, value))
    }
  }

  updateActiveCompany(event, index, value) {
    const { dispatch } = this.props
    dispatch(selectActivateCompany(value))
  }

  updateActiveBuilding(event, index, value) {
    const { dispatch } = this.props
    dispatch(selectActivateBuilding(value))
  }

  activateUser() {
    const { dispatch } = this.props
    dispatch(activateUser(this.props.selectedUser._id, this.props.selectedCompanyId, this.props.selectedBuildingId))
  }

  deleteUser(user) {
    const { dispatch } = this.props
    dispatch(deleteUser(user))
  }

  closeActivateUserDialog() {
    const { dispatch } = this.props
    dispatch(closeActivateDialog())
  }

  showActivateUserDialog(userIndex) {
    const { dispatch } = this.props
    let selectedUser = this.props.users.find(user => user.index == userIndex)
    if (selectedUser) {
      dispatch(showActivateDialog(selectedUser))
    }
  }

  updateFilter(name, event, index, value) {
    const { dispatch } = this.props
    dispatch(updateFilter(name, value))
  }

  updateUserBuildings(user, index, test, values) {
    const { dispatch } = this.props
    dispatch(updateBuildings(user._id, values))
  }

  updateUserCompanies(user, index, test, values) {
    const { dispatch } = this.props
    dispatch(updateCompanies(user._id, values))
  }

  onPageChanged(newPageNumber) {
    const { dispatch } = this.props
    if (newPageNumber != this.props.pageNumber) dispatch(changePage(newPageNumber))
  }

  onSearchStringChanged(event) {
    let newString = event.target.value
    if (newString != this.props.searchString) this.performSearchSTringChanged(newString)
  }

  resendVerificationEmail(user, email) {
    const { dispatch } = this.props

    let users = this.props.users
    users = users.filter(x => {
      if (x.email !== email || x._id == user._id) {
        return false
      }
      return true
    })

    if (!email || email.length === 0) {
      return dispatch(resentEmailFailed('Please enter an email address.'))
    }

    if (!validateEmail(email)) {
      return dispatch(resentEmailFailed('Please insert a valid email'))
    }

    if (users.length > 0) {
      return dispatch(resentEmailFailed('There is a user with this email already associated!'))
    }
    dispatch(resendVerificationEmail(user, email))
  }

  closeResendVerificationEmailModal() {
    const { dispatch } = this.props
    dispatch(closeResentEmail())
  }

  toggleInactiveUsers(event, enabled) {
    const { dispatch } = this.props
    dispatch(showInactiveUsers(enabled))
  }

  showUsernameDialog(selectedUser) {
    const { dispatch } = this.props
    dispatch(showUsernameDialog(selectedUser))
  }

  showEmailDialog(selectedUser) {
    const { dispatch } = this.props
    dispatch(showEmailDialog(selectedUser))
  }

  closeUsernameDialog() {
    const { dispatch } = this.props
    dispatch(closeUsernameDialog())
  }

  closeDevicesInformation() {
    const { dispatch } = this.props
    dispatch(closeDevicesInformation())
  }

  currentUsernameChanged(event) {
    const { dispatch } = this.props
    dispatch(currentUsernameChanged(event.target.value))
  }

  currentEmailChanged(event) {
    const { dispatch } = this.props
    dispatch(currentEmailChanged(event.target.value))
  }

  performSearchSTringChanged(newSearchString) {
    const { dispatch } = this.props
    dispatch(changeSearchString(newSearchString))
  }

  showDevicesInformation(selectedUser, deviceType) {
    const { dispatch } = this.props
    dispatch(showDevicesInformation(selectedUser, deviceType))
  }

  showIOSDevicesInformation(selectedUser) {
    this.showDevicesInformation(selectedUser, 'ios')
  }
  showANDROIDDevicesInformation(selectedUser) {
    this.showDevicesInformation(selectedUser, 'android')
  }
  showWEBDevicesInformation(selectedUser) {
    this.showDevicesInformation(selectedUser, 'web')
  }

  showLogins(user) {
    let logins = user.logins
    let login = []
    let isFacebook = false
    let isGoogle = false
    let isApp = false
    let isLinkedin = false
    let isInstagram = false

    {
      logins = logins && logins.map(x => {
        if (x.type === 'linkedin' && isLinkedin === false) {
          login.push(
            <div style={{ padding: '2px', float: 'left' }}>
              <FontAwesomeIcon icon={['fab', 'linkedin']} size='1x' />
            </div>
          )
          isLinkedin = true
        }
        if (x.type === 'facebook' && isFacebook === false) {
          login.push(
            <div style={{ padding: '2px', float: 'left' }}>
              <FontAwesomeIcon icon={['fab', 'facebook']} size='1x' />
            </div>
          )
          isFacebook = true
        }
        if (x.type === 'instagram' && isInstagram === false) {
          login.push(
            <div style={{ padding: '2px', float: 'left' }}>
              <FontAwesomeIcon icon={['fab', 'instagram']} size='1x' />
            </div>
          )
          isInstagram = true
        }

        if (x.type === 'google' && isGoogle === false) {
          login.push(
            <div style={{ padding: '2px', float: 'left' }}>
              <FontAwesomeIcon icon={['fab', 'google']} size='1x' />
            </div>
          )
          isGoogle = true
        }
        if (x.type === 'app' && isApp === false) {
          login.push(
            <div style={{ padding: '2px', float: 'left' }}>
              <FontAwesomeIcon icon={['fas', 'sign-in-alt']} size='1x' />
            </div>
          )
          isApp = true
        }
      })
    }

    if (user.invitation) {
      login.push(
        <div style={{ padding: '2px', float: 'left' }}>
          <FontAwesomeIcon icon={['fa', 'user']} size='1x' />
        </div>
      )
    }

    return <span>{login}</span>
  }

  showDevices(user) {
    let devices = user.devices
    let device = []
    let isIos = false
    let isAndroid = false
    let isWeb = false

    {
      devices = devices.map(x => {
        if (x.type === 'ios' && isIos === false) {
          device.push(
            <div style={{ padding: '4px', float: 'left' }}>
              <FlatButton
                style={{ minWidth: '10px', float: 'left', padding: '5px' }}
                onClick={this.showIOSDevicesInformation.bind(this, user)}>
                <FontAwesomeIcon icon={['fab', 'apple']} size='1x' />
              </FlatButton>
            </div>
          )
          isIos = true
        }
        if (x.type === 'android' && isAndroid === false) {
          device.push(
            <div style={{ padding: '4px', float: 'left' }}>
              <FlatButton
                style={{ minWidth: '10px', float: 'left', padding: '5px' }}
                onClick={this.showANDROIDDevicesInformation.bind(this, user)}>
                <FontAwesomeIcon icon={['fab', 'android']} size='1x' />
              </FlatButton>
            </div>
          )
          isAndroid = true
        }
        if (x.type === 'web' && isWeb === false) {
          device.push(
            <div style={{ padding: '4px', float: 'left' }}>
              <FlatButton
                style={{ minWidth: '10px', float: 'left', padding: '5px' }}
                onClick={this.showWEBDevicesInformation.bind(this, user)}>
                <FontAwesomeIcon icon={['fas', 'desktop']} size='1x' />
              </FlatButton>
            </div>
          )
          isWeb = true
        }
      })
    }
    let test = device
    return <span>{test}</span>
  }

  listDevices(selectedUser) {
    let devices = selectedUser.devices
    let device = []

    device.push(
      <tr>
        <td> Type </td>
        <td> | Device </td>
        <td> | Operating Version </td>
        <td> | Registration Date </td>
        <td> | Last Activity Date </td>
      </tr>
    )

    {
      devices = devices.map(x => {
        if (x.type === this.props.deviceType) {
          device.push(
            <tr>
              <td>{' ' + (x.type ? x.type : '') + ' '} </td>
              <td>{' | ' + (x.description ? x.description : '') + ' '} </td>
              <td>{' | ' + (x.os ? x.os : '') + ' '} </td>
              <td>{' | ' + (x.createdAt ? moment(x.createdAt).format('DD-MM-YYYY hh:mm') : '') + ' '} </td>
              <td>{' | ' + (x.activeDate ? moment(x.activeDate).format('DD-MM-YYYY hh:mm') : '') + ' '} </td>
            </tr>
          )
        }
      })
    }
    return <table>{device}</table>
  }

  showSpinner() {
    const { dispatch } = this.props
    dispatch(showSpinner())
  }

  render() {
    var users = this.props.users

    const actions = [
      <FlatButton label='Cancel' primary={true} onClick={this.closeActivateUserDialog.bind(this)} />,
      <FlatButton label='Activate' primary={true} onClick={this.activateUser.bind(this)} />
    ]

    const updateUsername = [
      <FlatButton label='Cancel' primary={true} onClick={this.closeUsernameDialog.bind(this)} />,
      <FlatButton label='Update username' primary={true} onClick={this.updateUserUsername.bind(this)} />
    ]

    const devicesInformation = [
      <FlatButton label='Cancel' primary={true} onClick={this.closeDevicesInformation.bind(this)} />
    ]

    const emailVerificationAction = [
      <div>
        {this.props.showResentEmailAlert ? (
          <span>
            {!this.showSpinner ? (
              <CircularProgress
                style={{ paddingLeft: '69px', paddingRight: '69px', verticalAlign: 'middle' }}
                size={20}
                thickness={1}
              />
            ) : (
              <FlatButton label='OK' primary={true} onClick={this.closeResendVerificationEmailModal.bind(this)} />
            )}
          </span>
        ) : (
          <div>
            <FlatButton
              style={{ width: '50px' }}
              label='CANCEL'
              primary={true}
              onClick={this.closeResendVerificationEmailModal.bind(this)}
            />
            <FlatButton
              label='SEND'
              primary={true}
              onClick={this.resendVerificationEmail.bind(this, this.props.selectedUser, this.props.typedEmail)}
            />
            <div style={{ color: 'red', float: 'left' }}>{this.props.error}</div>
          </div>
        )}
      </div>
    ]

    // fixed weird issues with status filter being undefined after clearing cache
    let status = this.props.filter.status
    if (!status) {
      status = ' '
    }

    if (this.props.usersFetched && this.props.companiesFetched && this.props.buildingsFetched) {
      if (this.props.users) {
        let searchString = this.props.usernameSearchValue ? this.props.usernameSearchValue.trim().toUpperCase().replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') : ""
        var users = this.props.users

        this.props.companies.sort(function(a, b) {
          if (a.name < b.name) return -1
          if (a.name > b.name) return 1
          return 0
        })

        let companies = this.props.companies

        let selectedBuildingId = this.props.selectedBuildingId

        companies = companies.filter(company => {
          let companyBuildings = company.buildings.map(building => building._id)
          return companyBuildings.indexOf(selectedBuildingId) > -1
        })

        return (
          <div>
            <Dialog
              actions={emailVerificationAction}
              title={!this.props.showResentEmailAlert ? 'Resend verification email' : 'Verification email was resent'}
              open={this.props.showEmailDialog}
              modal={true}>
              {!this.props.showResentEmailAlert ? (
                <TextField
                  style={{ paddingRight: '20px', float: 'left' }}
                  floatingLabelText='Email'
                  name='Email'
                  open={this.props.showEmailDialog && this.props.selectedUser}
                  value={this.props.typedEmail ? this.props.typedEmail : ''}
                  onChange={this.currentEmailChanged.bind(this)}
                />
              ) : null}
            </Dialog>

            <Dialog
              autoDetectWindowHeight={true}
              autoScrollBodyContent={true}
              repositionOnUpdate={true}
              actions={devicesInformation}
              title='Devices information'
              modal={true}
              open={this.props.showDevicesInformation && this.props.selectedUser}>
              <div>{this.props.selectedUser ? <div> {this.listDevices(this.props.selectedUser)} </div> : <div />}</div>
            </Dialog>

            <Dialog
              actions={updateUsername}
              title='Change Username'
              open={this.props.showUsernameDialog && this.props.selectedUser}>
              <TextField
                style={{ paddingRight: '20px', float: 'left' }}
                floatingLabelText='Username'
                name='User name'
                value={this.props.typedUsername ? this.props.typedUsername : ''}
                onChange={this.currentUsernameChanged.bind(this)}
              />
            </Dialog>

            <Dialog
              className='scrollPaper'
              scroll='paper'
              actions={actions}
              title='Activate User'
              modal={true}
              open={this.props.showActivateDialog}>
              <div style={{ paddingLeft: '20px', paddingRight: '20px', float: 'left', width: '100%' }}>
                {this.props.selectedUser != null && this.props.selectedUser.requestedBuilding != null ? (
                  <div>
                    <span>Requested Building: {this.props.selectedUser.requestedBuilding}</span>
                    <br />
                    <Divider />
                  </div>
                ) : (
                  <span />
                )}

                <SelectField
                  floatingLabelText='Building'
                  value={this.props.selectedBuildingId}
                  onChange={this.updateActiveBuilding.bind(this)}>
                  <MenuItem value={undefined} primaryText='All' />
                  {this.props.buildings.map((building, index) => (
                    <MenuItem value={building._id} primaryText={building.name} />
                  ))}
                </SelectField>
              </div>

              <div style={{ paddingLeft: '20px', paddingRight: '20px', float: 'left', width: '100%' }}>
                <br />
                <br />
                {this.props.selectedUser != null && this.props.selectedUser.requestedCompany != null ? (
                  <div>
                    <span>Requested Company: {this.props.selectedUser.requestedCompany}</span>
                    <br />
                    <Divider />
                  </div>
                ) : null}

                <SelectField
                  style={{ float: 'left' }}
                  floatingLabelText='Company'
                  onChange={this.updateActiveCompany.bind(this)}
                  value={this.props.selectedCompanyId}>
                  {companies.map((company, index) => (
                    <MenuItem value={company._id} primaryText={company.name} />
                  ))}
                </SelectField>
              </div>
            </Dialog>

            <article>
              <details open={!isMobile}>
                <summary className={isMobile ? 'noselect' : 'hidden'}>Filters</summary>
                <Table selectable={false}>
                  <TableBody displayRowCheckbox={false}>
                    <TableRow displayBorder={false} selectable={false}>
                      <TableRowColumn
                        className='info'
                        style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '2%' }}>
                        <SelectField
                          style={{ marginRight: '20px', float: 'left' }}
                          floatingLabelText='Building'
                          value={this.props.filter.buildingId}
                          onChange={this.updateFilter.bind(this, 'buildingId')}>
                          <MenuItem value=' ' primaryText='All Buildings' />
                          {this.props.buildings.map((building, index) => (
                            <MenuItem value={building._id} primaryText={building.name} />
                          ))}
                        </SelectField>
                      </TableRowColumn>

                      <TableRowColumn
                        className='info'
                        style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '2%' }}>
                        <SelectField
                          style={{ marginRight: '20px', float: 'left' }}
                          floatingLabelText='Company'
                          value={this.props.filter.companyId}
                          onChange={this.updateFilter.bind(this, 'companyId')}>
                          <MenuItem value=' ' primaryText='All Companies' />
                          {this.props.companies.map((company, index) => (
                            <MenuItem value={company._id} primaryText={company.name} />
                          ))}
                        </SelectField>
                      </TableRowColumn>

                      <TableRowColumn
                        className='info'
                        style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '2%' }}>
                        <SelectField
                          style={{ marginRight: '20px', float: 'left' }}
                          floatingLabelText='Status'
                          value={status}
                          onChange={this.updateFilter.bind(this, 'status')}>
                          <MenuItem value=' ' primaryText='All' />
                          {this.props.filterStatuses.map((status, index) => (
                            <MenuItem value={status.value} primaryText={status.name} />
                          ))}
                        </SelectField>
                      </TableRowColumn>

                      <TableRowColumn
                        className='info'
                        style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '2%' }}>
                        <TextField
                          style={{ marginRight: '20px', float: 'left' }}
                          floatingLabelText='Search'
                          defaultValue={this.props.searchString}
                          onChange={this.onSearchStringChanged.bind(this)}
                          hintText='Username, email or invitation'
                          fullWidth={true}
                        />
                      </TableRowColumn>

                      <TableRowColumn
                        className='info'
                        style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '2%' }}>
                        <Toggle
                          style={{ float: 'left', marginTop: '40px' }}
                          onToggle={this.toggleInactiveUsers.bind(this)}
                          toggled={this.props.showInactiveUsers}
                          label='Inactive users only'
                          labelPosition='right'
                          fullWidth={true}
                        />
                      </TableRowColumn>
                    </TableRow>
                  </TableBody>
                </Table>
              </details>
            </article>

            <div style={{ float: 'left', width: '100%', marginTop: '15px' }}>
              <Pagination
                total={Math.ceil(this.props.totalUsersAfterFilters / this.props.itemsPerPage)}
                current={this.props.pageNumber}
                display={this.props.display}
                onChange={this.onPageChanged.bind(this)}
              />
            </div>
            <br />
            <div style={{ float: 'left', width: '100%', margin: '0 auto' }}>
              <Table
                selectable={false}
                style={{ tableLayout: 'auto', overflowX: 'auto' }}
                fixedHeader={true}
                className='users-table'>
                <TableBody displayRowCheckbox={false}>
                  <div
                    onClick={e => {
                      e.preventDefault()
                      e.stopPropagation()
                    }}>
                    <TableBody displayRowCheckbox={false}>
                      <TableRow selectable={false}>
                        <TableHeaderColumn className='info headerCol' style={{ width: '2%' }}>
                          {/* <div onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}> */}
                          ID
                          {/* </div>   */}
                        </TableHeaderColumn>
                        <TableHeaderColumn className='info headerCol' style={{ width: '3%' }}>
                          {/* <div onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}> */}
                          Email
                          {/* </div> */}
                        </TableHeaderColumn>

                        <TableHeaderColumn className='info headerCol' style={{ width: '3%' }}>
                          {/* <div onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                        }}> */}

                          {/* </div>   */}
                        </TableHeaderColumn>
                        <TableHeaderColumn className='info headerCol' style={{ width: '3%' }}>
                          {/* <div onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                        }}> */}

                          {/* </div>   */}
                        </TableHeaderColumn>
                        <TableHeaderColumn className='info headerCol' style={{ width: '3%' }}>
                          {/* <div onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                        }}>
                        </div> */}
                        </TableHeaderColumn>
                        <TableHeaderColumn className='info headerCol' style={{ width: '3%' }}>
                          {/* <div onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                        }}> */}
                          {/* </div> */}
                        </TableHeaderColumn>
                        <TableHeaderColumn className='info headerCol' style={{ width: '10%' }}>
                          {/* <div onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                        }}> */}
                          {/* </div> */}
                        </TableHeaderColumn>
                        <TableHeaderColumn className='info headerCol' style={{ width: '1%' }}>
                          {/* <div onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                        }}> */}
                          {/* </div> */}
                        </TableHeaderColumn>
                      </TableRow>
                    </TableBody>

                    <hr />

                    {users.map(function(user, index) {
                      var userBuildingsIds = []

                      if (user.buildings) {
                        userBuildingsIds = user.buildings
                        userBuildingsIds = userBuildingsIds.map(building => building._id)
                      }

                      var userCompaniesIds = []

                      if (user.companies) {
                        userCompaniesIds = user.companies
                        userCompaniesIds = userCompaniesIds.map(company => company._id)
                      }

                      return (
                        <TableBody displayRowCheckbox={false} className='users-table-row'>
                          <TableRow displayBorder={false} selectable={false}>
                            <TableRowColumn
                              className='info'
                              style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '2%' }}>
                              {/* <div onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}> */}
                              <label className='text-label'> ID: {user.index}</label>
                              {/* </div>   */}
                            </TableRowColumn>
                            <TableRowColumn
                              className='info'
                              style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                              {/* <div onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                          }}> */}
                              {user.invitation ? (
                                <label className='text-label'>
                                  {' '}
                                  ID: {user._id} ({user.invitation})
                                </label>
                              ) : (
                                <label className='text-label'> Email: {user.email}</label>
                              )}
                              <br />
                              {!user.invitation ? (
                                <label className='text-label'>
                                  {user.fullName}
                                  <FlatButton
                                    icon={<Edit />}
                                    style={iconStyle}
                                    primary={true}
                                    onClick={this.showUsernameDialog.bind(this, user)}
                                  />
                                </label>
                              ) : (
                                <label />
                              )}
                              <br />{' '}
                              {user.lastDate ? (
                                <span className='text-label'>
                                  Last active date : {moment(user.lastDate).format('DD-MM-YYYY hh:mm')}
                                </span>
                              ) : (
                                ''
                              )}
                              {/* {user.devices} */}
                              {user.active == 0 ? (
                                <div>
                                  <a onClick={this.showEmailDialog.bind(this, user)} className='text-label link'>
                                    Resend Verification Email
                                  </a>
                                </div>
                              ) : (
                                <div />
                              )}
                              {/* </div> */}
                            </TableRowColumn>

                            <TableRowColumn
                              className='info'
                              style={{
                                wordWrap: 'break-word',
                                whiteSpace: 'normal',
                                width: '3%',
                                paddingRight: '10px'
                              }}>
                              {/* <div onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                          }}> */}
                              <span>{this.showDevices(user)}</span>
                              {/* </div> */}
                            </TableRowColumn>
                            <TableRowColumn
                              className='info'
                              style={{
                                wordWrap: 'break-word',
                                whiteSpace: 'normal',
                                width: '3%',
                                paddingRight: '10px'
                              }}>
                              {/* <div onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                          }}> */}
                              <span>{this.showLogins(user)}</span>
                              {/* </div> */}
                            </TableRowColumn>

                            <TableRowColumn
                              className='info'
                              style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                              {/* <div onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}> */}
                              <SelectField
                                labelStyle={{ fontSize: '12px' }}
                                floatingLabelText='Status'
                                value={user.status}
                                onChange={this.updateUserStatus.bind(this, user.index)}
                                fullWidth={true}
                                className='upper-select'>
                                {this.props.statuses.map((status, index) => (
                                  <MenuItem
                                    innerDivStyle={{ fontSize: '12px' }}
                                    className='info'
                                    value={status.value}
                                    primaryText={status.name}
                                  />
                                ))}
                              </SelectField>

                              {user.status === 'requiresActivation' ||
                              user.status === 'requiresManualActivation' ||
                              user.status === 'pendingRegistration' ||
                              this.props.enabled ? (
                                <div className='text-label'>{user.requestedCompany}</div>
                              ) : (
                                <SelectField
                                  multiple={true}
                                  labelStyle={{ fontSize: '12px' }}
                                  floatingLabelText='Company'
                                  value={userCompaniesIds}
                                  onChange={this.updateUserCompanies.bind(this, user)}
                                  fullWidth={true}
                                  class='bottom-select'>
                                  {this.props.companies.map((company, index) => (
                                    <MenuItem
                                      value={company._id}
                                      primaryText={company.name}
                                      checked={userCompaniesIds && userCompaniesIds.indexOf(company._id) > -1}
                                    />
                                  ))}
                                </SelectField>
                              )}
                              {/* </div> */}
                            </TableRowColumn>

                            <TableRowColumn
                              className='info'
                              style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                              {/* <div onClick={(e) => {
                          e.preventDefault();
                            e.stopPropagation();
                        }}>           */}
                              <SelectField
                                labelStyle={{ fontSize: '12px' }}
                                floatingLabelText='Role'
                                value={user.role}
                                onChange={this.updateUserRole.bind(this, user.index)}
                                fullWidth={true}
                                class='upper-select'>
                                {this.props.roles.map((role, index) => (
                                  <MenuItem
                                    innerDivStyle={{ fontSize: '12px' }}
                                    value={role.value}
                                    primaryText={role.name}
                                  />
                                ))}
                              </SelectField>

                              {user.status === 'requiresActivation' ||
                              user.status === 'requiresManualActivation' ||
                              user.status === 'pendingRegistration' ? (
                                <div className='text-label'>{user.requestedBuilding}</div>
                              ) : (
                                <SelectField
                                  multiple={true}
                                  labelStyle={{ fontSize: '12px' }}
                                  floatingLabelText='Building'
                                  value={userBuildingsIds}
                                  onChange={this.updateUserBuildings.bind(this, user)}
                                  fullWidth={true}
                                  class='bottom-select'>
                                  {this.props.buildings.map((building, index) => (
                                    <MenuItem
                                      value={building._id}
                                      primaryText={building.name}
                                      checked={userBuildingsIds && userBuildingsIds.indexOf(building._id) > -1}
                                    />
                                  ))}
                                </SelectField>
                              )}
                              {/* </div> */}
                            </TableRowColumn>

                            <TableRowColumn
                              className='info'
                              style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                              {/* <div onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                          }}> */}
                              {user.status === 'requiresManualActivation' || user.status === 'pendingRegistration' ? (
                                user.active ? (
                                  <div>
                                    <FlatButton
                                      label='Activate'
                                      primary={true}
                                      style={style}
                                      onClick={this.showActivateUserDialog.bind(this, user.index)}
                                    />
                                  </div>
                                ) : (
                                  <div className='text-label'>Email not confirmed</div>
                                )
                              ) : (
                                <div />
                              )}
                              {/* </div> */}
                            </TableRowColumn>
                            <TableRowColumn
                              className='info'
                              style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                              {/* <div onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                          }}> */}
                              {this.props.role.length > 1 && this.props.role.charAt(1) == '2' ? (
                                <ConfirmButton
                                  key={user._id}
                                  isFlat={true}
                                  style={iconStyle}
                                  icon={<Delete />}
                                  confirmMessage='	&#10004;'
                                  cancelMessage='X'
                                  secondary={true}
                                  onSubmit={this.deleteUser.bind(this, user)}
                                />
                              ) : (
                                <div />
                              )}
                              {/* </div>   */}
                            </TableRowColumn>
                          </TableRow>

                          <TableRow style={{ height: '1' }} displayBorder={false}>
                            <TableRowColumn
                              colSpan={6}
                              className='info'
                              style={{ height: '1', wordWrap: 'break-word', whiteSpace: 'normal', width: '50%' }}>
                              {/* <div onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                          }}> */}
                              <Divider />
                              {/* </div> */}
                            </TableRowColumn>
                          </TableRow>
                        </TableBody>
                      )
                    }, this)}
                  </div>
                </TableBody>
              </Table>
              <br />
              <div style={{ float: 'left', width: '100%', marginTop: '15px' }}>
                <Pagination
                  total={Math.ceil(this.props.totalUsersAfterFilters / this.props.itemsPerPage)}
                  current={this.props.pageNumber}
                  display={this.props.display}
                  onChange={this.onPageChanged.bind(this)}
                />
              </div>
              <br />
              <br />
              <br />
              <br />
            </div>
          </div>
        )
      } else {
        return (
          <Card style={{ width: '100%', height: '100%' }}>
            <CardText style={{ position: 'relative', width: '100%', height: '100%' }}>No Users</CardText>
          </Card>
        )
      }
    } else {
      return (
        <Card style={{ width: '100%', height: '100%' }}>
          <CardText style={{ position: 'relative', width: '100%', height: '100%' }} />
        </Card>
      )
    }
  }
}

const mapStateToProps = state => {
  const { isFetching } = state.usersReducer

  if (isFetching) {
    return {
      isFetching
    }
  } else {
    return state.usersReducer

  }
}

export default withRouter(connect(mapStateToProps)(Users))



// WEBPACK FOOTER //
// ./src/containers/Users.js